import React from 'react'

export const VerticalConnection = ({idCenario = 0, isTransparente = false, distance}) => {
    return (
        <>
            {idCenario===0 && <div id={111} className={isTransparente ? 'vertical-connection-transparente' : 'vertical-connection'} align="center">{distance}</div>}
            {idCenario===1 && <div id={111} className={isTransparente ? 'vertical-connection-transparente' : 'vertical-connection-cenario1'} align="center">{distance}</div>}
            {idCenario===2 && <div id={111} className={isTransparente ? 'vertical-connection-transparente' : 'vertical-connection-cenario2'} align="center">{distance}</div>}
        </>
    )
}

export default VerticalConnection
